/**
 * @private
 * @deprecated https://hello.jira.atlassian.cloud/browse/EDITOR-2872
 * To be removed as part of Block menu project release
 */
export var FORMAT_MENU_ITEM = {
  key: 'nested-menu-format-section-primary'
};

/**
 * @private
 * @deprecated
 */
export var NESTED_FORMAT_MENU_SECTION = {
  key: 'nested-menu-format-section-primary'
};